import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/home";
import TodoList from "./pages/todo/todo-list";
import FormDemo from "./pages/form/form-demo";
import Register from "./pages/ecommerce/register";
import ProductList from "./pages/ecommerce/product-list";
import SharedLayout from "./pages/ecommerce/dashboard-layout";
import ProtectedRoute from "./pages/ecommerce/components/ProtectedRoute";
import Checkout from "./pages/ecommerce/Checkout";
import PaymentSuccess from "./pages/ecommerce/PaymentSuccess";
import PaymentFail from "./pages/ecommerce/PaymentFail";
import Profile from "./pages/ecommerce/profile";
import TestDataGenerator from "./pages/test-data/test-data-generator";
import TagManager from "react-gtm-module";
import FlightBookingDashboard from "./pages/flight-app/flight-booking-dashboard";

function App() {
  TagManager.initialize({
    gtmId: "GTM-KSW3TXHH",
  });
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/todo-list" element={<TodoList />} />
        <Route path="/form-demo" element={<FormDemo />} />
        <Route path="/test-data-generator" element={<TestDataGenerator />} />
        <Route path="/e-commerce/register" element={<Register />} />
        <Route
          path="/e-commerce"
          element={
            <ProtectedRoute>
              <SharedLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/e-commerce/product-list" element={<ProductList />} />
          <Route path="/e-commerce/checkout" element={<Checkout />} />
          <Route
            path="/e-commerce/payment-success"
            element={<PaymentSuccess />}
          />
          <Route path="/e-commerce/payment-fail" element={<PaymentFail />} />

          <Route path="/e-commerce/profile" element={<Profile />} />
        </Route>
        <Route
          path="/flight-booking-dashboard"
          element={<FlightBookingDashboard />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
